export const ABORT_SIGNAL_TIMEOUT = 30000;
